import { RetryHandlerType } from 'services/api/ApiClientService/types';

export const retryHandler =
    (callback?: RetryHandlerType): RetryHandlerType =>
    (retryCount, error, requestConfig) => {
        if (callback) callback(retryCount, error, requestConfig);
    };
